import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useLocationStore } from '@entities/Location'

import { useErrorInfoModal } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import {
  CustomerAddress,
  useZonesForGeoPointLazyQuery,
  ZonesForGeoPointQuery,
} from '@shared/generated'


export function useZonesFromAddress () {
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()
  const { selectedAddress, isPickup } = useAddressStore()

  const { currentCity } = useLocationStore()

  const [ zones, setZones ] = useState<
    ZonesForGeoPointQuery['zonesForGeoPoint'] | null
  >(null)

  const [ fetchZonesForGeopoint, { loading } ] = useZonesForGeoPointLazyQuery()

  useEffect(() => {
    const isCustomer = (addr: unknown): addr is CustomerAddress => {
      return typeof addr === 'object' && addr !== null && 'shop' in addr
    }
    
    const fetchZones = async () => {
      try {
        console.log('Fetching zones for geopoint...', {
          latitude:
            selectedAddress?.customerGeoPoint?.latitude ??
            (isCustomer(selectedAddress)
              ? selectedAddress.shop?.shopGeoPoint?.latitude
              : (currentCity?.defaultShop?.shopGeoPoint?.latitude ?? undefined)),
          longitude:
            selectedAddress?.customerGeoPoint?.longitude ??
            (isCustomer(selectedAddress)
              ? selectedAddress.shop?.shopGeoPoint?.longitude
              : (currentCity?.defaultShop?.shopGeoPoint?.longitude ?? undefined)),
        })
        const res = await fetchZonesForGeopoint({
          variables: {
            point: {
              latitude:
                selectedAddress?.customerGeoPoint?.latitude ??
                (isCustomer(selectedAddress)
                  ? selectedAddress.shop?.shopGeoPoint?.latitude
                  : (currentCity?.defaultShop?.shopGeoPoint?.latitude ?? undefined)),
              longitude:
                selectedAddress?.customerGeoPoint?.longitude ??
                (isCustomer(selectedAddress)
                  ? selectedAddress.shop?.shopGeoPoint?.longitude
                  : (currentCity?.defaultShop?.shopGeoPoint?.longitude ?? undefined)),
            },
          },
        })

        console.log('result of fetching', res.data)

        if (res.data?.zonesForGeoPoint) {
          setZones(res.data.zonesForGeoPoint)
        }
      }
      catch (error) {
        console.error('Ошибка при получении зон:', error)
        openErrorInfoModal({
          description: te('fetch_zones'),
        })
      }
    }

    fetchZones()
  }, [ fetchZonesForGeopoint, selectedAddress, currentCity ])

  const zone = zones?.[0]

  console.log(zone, zones)

  return {
    zones,
    minOrderCost: zone?.minOrderCost ?? 0,
    deliveryCost: zone?.delivery_cost ?? 0,
    freeSlotDeliveryCostFrom: zone?.freeSlotDeliveryCostFrom ?? 0,
    isPickup,
    loading,
  }
}
